import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { VscBracketError  } from "react-icons/vsc";

import './error.scss'

function Me() {
  const { t } = useTranslation()

  useEffect(() => {
    document.title = '404 - Page Not Found | Dwain'
  }, [])

  return (
    <main className='page-error'>
      <div className='error-container'>
        <h1 className='container-title'>4<VscBracketError  />4</h1>
        <p className='container-subTitle'>{t('error.title')}</p>
      </div>
    </main>
  )
}

export default Me
